import { useEffect, useRef, useCallback } from 'react';
import io from 'socket.io-client';

const useWebSocket = (onUpdate) => {
  const socketRef = useRef(null);
  const isConnectedRef = useRef(false);

  useEffect(() => {
    // Connect to WebSocket server
    const socket = io(window.location.origin, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
      console.log('WebSocket connected');
      isConnectedRef.current = true;
    });

    socket.on('disconnect', () => {
      console.log('WebSocket disconnected');
      isConnectedRef.current = false;
    });

    // Listen for updates from other users
    socket.on('players-updated', (data) => {
      if (onUpdate) onUpdate('players', data);
    });

    socket.on('tournaments-updated', (data) => {
      if (onUpdate) onUpdate('tournaments', data);
    });

    socket.on('tournament-players-updated', (data) => {
      if (onUpdate) onUpdate('tournamentPlayers', data);
    });

    socket.on('rounds-updated', (data) => {
      if (onUpdate) onUpdate('rounds', data);
    });

    socket.on('results-updated', (data) => {
      if (onUpdate) onUpdate('results', data);
    });

    socket.on('standings-updated', (data) => {
      if (onUpdate) onUpdate('standings', data);
    });

    socketRef.current = socket;

    return () => {
      socket.disconnect();
    };
  }, [onUpdate]);

  const emit = useCallback((event, data) => {
    if (socketRef.current && isConnectedRef.current) {
      socketRef.current.emit(event, data);
    }
  }, []);

  return { emit, isConnected: isConnectedRef.current };
};

export default useWebSocket;
